import './App.scss';
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { ListRoutes } from "./routes";

export default function App() {
  const loadingIcon = (
    <LoadingOutlined
      style={{
        fontSize: 44,
        color: '#A51435'
      }}
      spin
    />
  );

  return (
    <div className="App">
      <Suspense fallback={<div className='loading-screen'><Spin size="large" tip="Loading" style={{ color: '#A51435' }} indicator={loadingIcon} /></div>}>
        <Routes>
          {
            ListRoutes.map((item, key) => (
              <Route key={key} exact path={item.path} element={<item.component />} />
            ))
          }
          <Route path="*" element={<center>Not Found!</center>} />
        </Routes>
      </Suspense>
    </div>
  );
}

